/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import { Typography } from '@material-ui/core';

const alignments = {
  i: 'inherit',
  l: 'left',
  c: 'center',
  r: 'right',
  j: 'justify',
};

const Text = ({
  v, a, g, p, t, h, c, i, children, ...props
}) => {
  // TODO: Add Localization Context to support mutlilangue keywords
  const text = t || children;
  return (
    <Typography
      variant={v || 'body2'}
      align={a ? alignments[a] : 'inherit'}
      gutterBottom={!!g}
      paragraph={!!p}
      color={c || 'inherit'}
      display={i ? 'inline' : 'initial'}
      {...props}
    >
      {text}
    </Typography>
  );
};

export default Text;
